/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerPortalResponseDto
 */
export interface CustomerPortalResponseDto {
    /**
     * Stripe customer portal URL for managing billing and subscriptions
     * @type {string}
     * @memberof CustomerPortalResponseDto
     */
    url: string;
}

/**
 * Check if a given object implements the CustomerPortalResponseDto interface.
 */
export function instanceOfCustomerPortalResponseDto(value: object): value is CustomerPortalResponseDto {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function CustomerPortalResponseDtoFromJSON(json: any): CustomerPortalResponseDto {
    return CustomerPortalResponseDtoFromJSONTyped(json, false);
}

export function CustomerPortalResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerPortalResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function CustomerPortalResponseDtoToJSON(json: any): CustomerPortalResponseDto {
    return CustomerPortalResponseDtoToJSONTyped(json, false);
}

export function CustomerPortalResponseDtoToJSONTyped(value?: CustomerPortalResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

